import { validateCommonSize as m } from "./highrise68.mjs";
const t = (o) => m(o) ? o : "sm";
export {
  t as fallbackSize,
  m as validateCommonSize
};
